import React, { Component } from 'react';
import { withRouter, NavLink, Link } from 'react-router-dom';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import { userName, logout } from '../Utils/FirebaseAuth';
import { auth } from 'firebase';
import "./Navbar.css"


class NavBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      authenticated: false,
      loading: true,
      userName: "",
    }
  }

  signOut = () => {
    logout();
  }

  componentDidMount() {
    auth().onAuthStateChanged((user) => {
      if (user) {
        this.setState({
          authenticated: true,
          loading: false,
          userName: auth().currentUser.displayName,
        });
      } else {
        this.setState({
          authenticated: false,
          loading: false,
        });
      }
    })
  }

  class(name) {
    // "blackColor " + constants.selectedTab == 'About Us' ? 'selected-tab' : ''
    let selectedClass = localStorage.getItem('selectedTab') == name ? 'selected-tab' : '';
    return `tabs light-font ${selectedClass}`
  }

  render() {

    return this.state.loading === true ? <h2>Loading...</h2> : (

      <Navbar expand="lg" variant="light" fixed="top">
        {/* <Navbar.Brand href="/Images/logo.png">Rate Review Repeat</Navbar.Brand> */}
        <Navbar.Brand href="/" className="p-0" onClick={() => { localStorage.setItem('selectedTab', 'Home') }}>
          {/* Rate Review Repeat */}
          <img src='/Images/LogoFinal.png' height="58px" />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" className="my-2" />
        <Navbar.Collapse id="responsive-navbar-nav NavLinkDiv">
          <Nav className="">
            {/* <Nav.Link className={this.class('Home')} onClick={() => { localStorage.setItem('selectedTab', 'Home') }} href="/">Home</Nav.Link> */}
            {/* <Nav.Link className='navlinkStyle hoverBlue'  href="/all-listing">All Listing</Nav.Link> */}
           {
             this.state.authenticated?
             <Nav.Link className='navlinkStyle hoverBlue' href="/userprofile/test">Profile Page</Nav.Link>:null
           }
            <Nav.Link className='navlinkStyle hoverBlue' href="/review">Reviews</Nav.Link>
            <Nav.Link className='navlinkStyle hoverBlue' href="/about">About Us</Nav.Link>
            {/* <Nav.Link className='navlinkStyle hoverBlue' href="/legal">Legal</Nav.Link> */}
            <Nav.Link className='navlinkStyle hoverBlue' href="/contactus">Contact Us</Nav.Link>
          </Nav>
          <Nav>
            {
              !this.state.authenticated &&
              <Nav.Link className='navbarBtn' href="/login">Sign In</Nav.Link>
            }
            
            {
              this.state.authenticated &&
              <div>
                {/* <label className="mr-2 text-white">Hello {this.state.userName}</label>
                <Button className="buttons btn-dark" onClick={this.signOut}>Sign Out</Button> */}

                {/* <Button variants="buttons">Sign In</Button> */}
                <button className='navlinkStyle hoverBlue linkLikeBtn' onClick={this.signOut}>Sign Out</button>

              </div>
            }
            {/* <button className='navbarBtn' href="/review">Write Review</button> */}
            {
              this.state.authenticated?
              <Nav.Link href='/addlisting' className='navbarBtn'>+ Add Listing</Nav.Link>:null
            }


          </Nav>
        </Navbar.Collapse>
      </Navbar>

    );
  }
}

export default withRouter(NavBar);